import React, { useState } from "react";
import { Link, useNavigate } from "react-router-dom";
import { ReactComponent as EmailIcon } from "../../../assets/@.svg";
import { ReactComponent as LockIcon } from "../../../assets/lock.svg";
import Input from "../../../component/common/Input";
import Button from "../../../component/common/Button";
import { useFormContext } from "react-hook-form";

const SignUp = () => {
  const navigate = useNavigate();
  const [terms, setTerms] = useState(false);

  const {
    register,
    handleSubmit,
    formState: { errors },
  } = useFormContext({});

  return (
    <div className="flex items-center justify-center min-h-screen bg-white p-[10px] sm:p-10">
      <div className="card w-[491px]">
        <h1 className="heading">Join ZoomVenues 🤝</h1>
        <p className="paragraph">
          Lorem ipsum dolor sit amet, consectetur adipiscing elit. Turpis morbi
          pulvinar venenatis non.
        </p>

        <div className="space-y-6">
          <Input
            Icon={EmailIcon}
            label={"Email"}
            placeholder={"Email address"}
            {...register("email")}
          />
          {errors.email && (
            <p className="text-red-500 text-sm">{errors.email.message}</p>
          )}
          <Input
            Icon={LockIcon}
            label={"Password"}
            type={"password"}
            placeholder={"Password (min. 8 characters)"}
            {...register("password")}
          />
          {errors.password && (
            <p className="text-red-500 text-sm">{errors.password.message}</p>
          )}

          <Input
            Icon={LockIcon}
            label={"Confirm Password"}
            type={"password"}
            placeholder={"Retype password"}
            {...register("confirmPassword")}
          />
          {errors.confirmPassword && (
            <p className="text-red-500 text-sm">
              {errors.confirmPassword.message}
            </p>
          )}
        </div>

        <div className="inline-flex space-x-2 mt-[44px] items-center">
          <label
            className="relative flex items-center rounded-full cursor-pointer"
            htmlFor="terms"
          >
            <input
              type="checkbox"
              className="relative h-4 w-4 cursor-pointer outline-300-gray rounded-md block"
              id="terms"
              onClick={() => setTerms(!terms)}
            />
          </label>
          <label
            className="mt-px font-light text-gray-700 cursor-pointer select-none"
            htmlFor="link"
          >
            <p className="flex text-[13px] font-medium leading-relaxed text-900-gray">
              I agree with the
              <Link
                to="/terms-and-conditions"
                className="block text-[13px] font-medium leading-relaxed text-[#306BFF] underline ml-1"
                style={{ textDecoration: "underline" }}
              >
                &nbsp;Terms & Conditions
              </Link>
            </p>
          </label>
        </div>
        {errors.terms && (
          <p className="text-red-500 text-sm">{errors.terms.message}</p>
        )}

        <Button
          content="Sign Up"
          classes={`mt-[19px] hover:bg-[#3872A5] duration-300 justify-center ${
            !terms ? "opacity-50" : ""
          }`}
          type="submit"
          disabled={!terms}
        />

        <Link
          to={"/user-sign-up"}
          className="text-blue-color text-center !underline my-2 "
        >
          Join as a Customer
        </Link>
      </div>
    </div>
  );
};

export default SignUp;
